import { FC } from 'react';
import { ReactComponent as Mail } from '../../assets/icon/mail.svg';
import { ReactComponent as Member } from '../../assets/icon/member.svg';
import { ReactComponent as Search } from '../../assets/icon/search.svg';
import { ReactComponent as Tel } from '../../assets/icon/tel.svg';
import { Link } from '../Link.client';
import { CartIcon } from './CartIcon.client';

export const DesktopHeaderDetail: FC<{ onClickSearch: () => void }> = ({ onClickSearch }) => (
  <div className="flex flex-row  items-center gap-x-6">
    <div className="flex flex-row items-center gap-x-2">
      {/* <div className="text-right text-[12px]">
        <p>お問合せ</p>
        <p>
          平日<span className="font-outfit">9:00-18:00</span>
        </p>
      </div> */}
      <Tel />
      <p className="text-2xl font-semibold">
        <span className="font-outfit font-normal">
          <a href="tel:0120-18-8800">0120-18-8800</a>
        </span>
      </p>
    </div>
    <ul className="flex flex-row gap-x-6">
      <li>
        <Link route="contact">
          <Mail />
        </Link>
      </li>
      <li>
        <button onClick={onClickSearch}>
          <Search />
        </button>
      </li>
      <li>
        <Link route="account">
          <Member />
        </Link>
      </li>
      <li>
        <Link route="cart">
          <CartIcon />
        </Link>
      </li>
    </ul>
  </div>
);
